import { FC } from 'react';
import styled from 'styled-components';
import { theme } from '../../../../../styles/theme';
import { Typography } from '../../../../style';
import { ContractDataProps } from '../contract-modal/ContractDetails';
import { StyledColumn, StyledRow } from './Style';

const GeneralPaymentDetails: FC<ContractDataProps> = (props) => {
  return (
    <Border data-testid='general-payment-details-border'>
      <Wrapper data-testid='general-payment-details-table'>
        <tbody>
          <StyledRow>
            <StyledColumn columnSize='col-sm-6'>
              <Typography
                size={theme.typography.h5}
                fontWeight={theme.typography.fontWeights.semibold}
                color={theme.palette.wetAsphalt}
              >
                Bank
              </Typography>
            </StyledColumn>
            <StyledColumn columnSize='col-sm-6'>
              <Typography
                size={theme.typography.h5}
                fontWeight={theme.typography.fontWeights.semibold}
                color={theme.palette.wetAsphalt}
              >
                Sold By
              </Typography>
            </StyledColumn>
          </StyledRow>
          <StyledRow>
            <StyledColumn columnSize='col-sm-6'>
              <Typography
                size={theme.typography.h4}
                fontWeight={theme.typography.fontWeights.normal}
                color={theme.palette.grey}
              >
                {props.data.bankName ? props.data.bankName : 'N/A'}
              </Typography>
            </StyledColumn>
            <StyledColumn columnSize='col-sm-6'>
              <Typography
                size={theme.typography.h4}
                fontWeight={theme.typography.fontWeights.normal}
                color={theme.palette.grey}
              >
                {props.data.soldBy}
              </Typography>
            </StyledColumn>
          </StyledRow>
        </tbody>
      </Wrapper>
    </Border>
  );
};

export default GeneralPaymentDetails;

const Wrapper = styled.table`
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 20px;
  display: flex;
  flex-direction: column;
  & tr {
    padding-top: 15px;
    line-height: 26px;
  }
  & tr:last-child {
    padding-top: 5px;
  }
  .col-sm-3 {
    padding-left: 13px;
    padding-right: 13px;
  }
`;

const Border = styled.div`
  border-bottom: 2px dashed ${theme.palette.lightGrey};
`;
